// Tag for graphql format
const gql = String.raw;

const getOnCreateAssignment = () => gql`
	subscription onCreatePayPlanAssignment {
		onCreatePayPlanAssignment {
			planId
			userId
			payPlanAssignment {
				_id
			}
			users {
				upcomingPayPlanAssignment {
					acknowledgementDate
					acknowledgementStatus {
						status
						statusDate
					}
					assignmentDate
					effectiveDate
					planId {
						_id
						name
					}
					position
					acknowledgementDocumentLink
					assignedBy
					packageId
				}
				_id
				locationId
				employeeId
				fullName
				position
				communications {
					acceptsTxt
					communicationType
					usage
					value
				}
				currentPayPlanAssignment {
					_id
					acknowledgementDate
					acknowledgementDocumentLink
					assignedBy
					assignmentDate
					effectiveDate
					planId {
						_id
						name
						position
					}
					position
				}
				payPlanAssignmentHistory {
					_id
					acknowledgementDate
					acknowledgementStatus {
						status
						statusDate
					}
					acknowledgementDocumentLink
					assignedBy
					assignmentDate
					effectiveDate
					planId {
						_id
						name
						position
					}
					position
					packageId
				}
				supervisor {
					_id
					fullName
				}
				preferences {
					landingLocation
					landingPage
				}
				hireDate
			}
		}
	}
`;

const getOnRemoveUser = () => gql`
	subscription onRemoveUserPayPlanAssignment {
		onRemoveUserPayPlanAssignment {
			_id
			locationId
			employeeId
			fullName
			position
			communications {
				acceptsTxt
				communicationType
				usage
				value
			}
			upcomingPayPlanAssignment {
				_id
				acknowledgementDate
				acknowledgementStatus {
					status
					statusDate
				}
				acknowledgementDocumentLink
				assignedBy
				assignmentDate
				planId {
					_id
					name
					position
				}
				effectiveDate
				position
				packageId
			}
			currentPayPlanAssignment {
				_id
				acknowledgementDate
				acknowledgementStatus {
					status
					statusDate
				}
				acknowledgementDocumentLink
				assignedBy
				assignmentDate
				effectiveDate
				planId {
					_id
					name
					position
				}
				position
			}
			payPlanAssignmentHistory {
				_id
				acknowledgementDate
				acknowledgementDocumentLink
				acknowledgementStatus {
					status
					statusDate
				}
				assignedBy
				assignmentDate
				effectiveDate
				planId {
					_id
					name
					position
				}
				position
			}
			supervisor {
				_id
				fullName
			}
			preferences {
				landingLocation
				landingPage
			}
			hireDate
		}
	}
`;

const getOnUpdateUser = () => gql`
	subscription onUpdateUserPayPlanAssignment {
		onUpdateUserPayPlanAssignment {
			_id
			locationId
			employeeId
			fullName
			position
			communications {
				acceptsTxt
				communicationType
				usage
				value
			}
			upcomingPayPlanAssignment {
				_id
				packageId
				acknowledgementDate
				acknowledgementDocumentLink
				acknowledgementStatus {
					status
					statusDate
					signingProgress {
						fullName
						roleId
						signedAt
					}
				}
				assignedBy
				assignmentDate
				planId {
					_id
					name
					position
					pdfAvailability
				}
				effectiveDate
				position
			}
			currentPayPlanAssignment {
				_id
				acknowledgementDate
				acknowledgementDocumentLink
				acknowledgementStatus {
					status
					statusDate
				}
				assignedBy
				assignmentDate
				effectiveDate
				planId {
					_id
					name
					position
				}
				position
				packageId
			}
			payPlanAssignmentHistory {
				_id
				acknowledgementDate
				acknowledgementDocumentLink
				assignedBy
				assignmentDate
				acknowledgementStatus {
					status
					statusDate
				}
				effectiveDate
				planId {
					_id
					name
					position
				}
				position
			}
			hireDate
		}
	}
`;

const getAssignmentsSubscriptions = () => [
	{
		context: "onCreatePayPlanAssignment",
		query: getOnCreateAssignment(),
	},
	{
		context: "onRemoveUserPayPlanAssignment",
		query: getOnRemoveUser(),
	},
	{
		context: "onUpdateUserPayPlanAssignment",
		query: getOnUpdateUser(),
	},
];

export { getAssignmentsSubscriptions, getOnCreateAssignment, getOnRemoveUser };
